module.exports = __webpack_public_path__ + "static/media/school-b.3d7cd1e1.jpg";